import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { LocalStorageService } from "ngx-webstorage";
import {
  ScoreCard,
  ScoreCardTypeEnum,
} from "../performance-score-card/performance-score-card.model";
import { PerformanceScoreCardService } from "../performance-score-card/performance-score-card.service";
import { QuarterService } from "../services/quarter.service";
import {
  Frequency,
  PerformanceScoreCard,
  PSCMetricDetails,
  ScoreCardMaster,
} from "./add-score-card.model";
import { ValidationDialogComponent } from "./validation-dialog";
import { ResponseDialogComponent } from "./response-dialog";

@Component({
  selector: "app-add-score-card",
  templateUrl: "./add-score-card.component.html",
  styleUrls: ["./add-score-card.component.scss"],
})
export class AddScoreCardComponent implements OnInit, AfterViewInit {
  isViewScoreCard: boolean = true;
  companyId: number;
  quarterList: any = [];
  currentUser: string;
  selectedQuarterId: number;
  quarterMonths: string;
  scoreCard: ScoreCard;
  teamName: string;
  selectedYear: Date;
  step: number = 0;
  selectedMetrics: Array<PSCMetricDetails> = [];
  YearPickerConfig: Partial<BsDatepickerConfig>;
  maxDate: Date;
  minDate: Date;
  errorMessages: string[] = [];
  frequencies: string[] = [Frequency.Monthly, Frequency.Weekly];
  scoreCardMaster: ScoreCardMaster;
  pscMetricDetails: Array<PSCMetricDetails> = [];
  performanceScoreCard: PerformanceScoreCard;
  scoreCardMasterId: number;
  quarterName: string;
  selectedYearName: Number;
  scoreCardMasterList: ScoreCardMaster[];
  WeekDateList = [];
  toBeDeletedMetrics: number[] = [];
  quarters: any;
  targetSymbolsList: string[] = ["<", "<=", ">", ">=", "==", "Yes", "No"];
  scoreCardPreview: boolean = false;
  quarterDetails = [];

  constructor(
    private storage: LocalStorageService,
    private scoreCardService: PerformanceScoreCardService,
    private quarterService: QuarterService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.YearPickerConfig = Object.assign(
      {},
      {
        containerClass: "theme-dark-blue",
        showWeekNumbers: false,
        dateInputFormat: "YYYY",
      }
    );
    this.currentUser = this.storage.retrieve("user");
    this.scoreCardService.scoreCard.subscribe((resp) => {
      if (!resp) {
        this.router.navigate(["performance-score-card"]);
        return;
      }
      this.scoreCard = resp;
      this.currentUser = this.storage.retrieve("user");
    });
  }

  ngOnInit(): void {
    this.companyId = this.storage.retrieve("companyID");
    this.maxDate = new Date();
    this.minDate = new Date("01/01/2020");
    this.scoreCardMasterId = Number(this.route.snapshot.paramMap.get("id"));
    this.step = Number(this.route.snapshot.paramMap.get("stepId"));
    if (this.scoreCard && this.scoreCard.TeamName) {
      this.teamName = this.scoreCard.TeamName;
    }

    this.scoreCardService
      .GetPerformanceScoreCardDetails(
        this.companyId,
        this.scoreCard.DepartmentId,
        this.scoreCard.TeamId,
        this.scoreCardMasterId
      )
      .subscribe((resp) => {
        // --- keep synchronous parsing minimal ---
        this.scoreCardMasterList = resp.Data;
        this.pscMetricDetails = resp.AdditionalData.PSCDetails || [];
        this.quarterDetails = resp.AdditionalData.QuarterDetails || [];

        // Defer any UI-bound assignments to next tick to avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          try {
            if (this.scoreCard.ScoreCardType === ScoreCardTypeEnum.Department) {
              this.scoreCardMasterList = this.scoreCardMasterList.filter(
                (ent) => ent.ScoreCardType === ScoreCardTypeEnum.Department
              );
            }
            if (this.scoreCard.ScoreCardType === ScoreCardTypeEnum.Team) {
              this.scoreCardMasterList = this.scoreCardMasterList.filter(
                (ent) => ent.TeamID === this.scoreCard.TeamId
              );
              this.pscMetricDetails = this.pscMetricDetails.filter(
                (ent) => ent.TeamID === this.scoreCard.TeamId
              );
            }

            this.getQuarters(this.quarterDetails);

            if (
              this.scoreCardMasterList &&
              this.scoreCardMasterList.length > 0
            ) {
              this.selectedMetrics = this.pscMetricDetails.filter(
                (ent) => ent.IsSelected === true
              );
            }

            // ensure defaults for metrics
            // For NEW scorecards, clear only week values. For EXISTING, keep loaded values.
            if (this.scoreCardMasterId === 0) {
              this.pscMetricDetails.forEach((ele) => {
                ele.Week1 =
                  ele.Week2 =
                  ele.Week3 =
                  ele.Week4 =
                  ele.Week5 =
                  ele.Week6 =
                    null;
                ele.Week7 =
                  ele.Week8 =
                  ele.Week9 =
                  ele.Week10 =
                  ele.Week11 =
                  ele.Week12 =
                  ele.Week13 =
                  ele.Week14 =
                    null;
              });
            }

            if (this.scoreCardMasterId != 0 && this.scoreCardMasterList) {
              this.scoreCardMaster = this.scoreCardMasterList.find(
                (ele) => ele.Id === this.scoreCardMasterId
              );
              this.selectedQuarterId = this.scoreCardMaster
                ? this.scoreCardMaster.QuarterId
                : 0;
              this.selectedYear = this.scoreCardMaster
                ? new Date("01/01/" + this.scoreCardMaster.Year)
                : null;

              if (this.selectedQuarterId) {
                const quarterFound = this.quarterList.find(
                  (ent) => ent.QuarterId == this.selectedQuarterId
                );
                this.quarterName = quarterFound
                  ? quarterFound.QuarterName
                  : undefined;
              }

              this.selectedYearName = this.selectedYear
                ? this.selectedYear.getFullYear()
                : undefined;

              if (this.quarters && this.selectedYearName) {
                const months = this.quarters.find(
                  (ent) => ent.QuarterId === this.selectedQuarterId
                ).QuarterMonths;
                this.WeekDateList = this.quarterService.getWeekMonths(
                  months,
                  Number(this.selectedYearName),
                  this.quarters[0].QuarterWeekDay,
                  this.quarters[0].QuarterWeekDate
                );
              }
            }

            this.processData();

            // After finishing initialization, sync the view
            this.safeStepChange(this.step);

            // ensure change detection runs after our deferred updates
            this.cdr.detectChanges();
          } catch (e) {
            // Fall back - if anything unexpected happens, still trigger view update
            this.cdr.detectChanges();
            console.error(e);
          }
        });
      });
  }

  ngAfterViewInit(): void {
    // Extra precaution: let Angular finish initial CD, then run another CD to stabilise view
    setTimeout(() => {
      try {
        this.cdr.detectChanges();
      } catch (e) {
        // ignore
      }
    });
  }

  getQuarters(quarterDetails): void {
    if (!quarterDetails || quarterDetails.length == 0) {
      return;
    }
    var selectedMonthId = this.quarterService
      .getMonths()
      .find((val) => val.MonthName == quarterDetails[0].MonthName).MonthId;
    this.quarters = this.quarterService.generateQuarters(
      selectedMonthId,
      this.companyId,
      this.currentUser,
      quarterDetails[0].QuarterWeekDay,
      quarterDetails[0].QuarterWeekDate
    );
    this.quarterList = [];
    this.quarters.forEach((val) => {
      this.quarterList.push({
        QuarterId: val.QuarterId,
        QuarterName: val.QuarterName,
        QuarterMonths: this.getQuarterMonths(val.QuarterMonths),
      });
    });
  }

  getQuarterMonths(quarters): string {
    var months = [];
    quarters.forEach((val) => {
      months.push(val.MonthName);
    });
    return months.join(",");
  }

  targetChange(metric): void {
    if (!metric.GreenTargetSymbol || metric.GreenTargetSymbol == "null") {
      metric.GreenTargetSymbol = null;
    } else {
      metric.GreenMaximum = null;
      if (metric.GreenTargetSymbol === "Yes") metric.GreenMinimum = 2;
      else if (metric.GreenTargetSymbol === "No") metric.GreenMinimum = 1;
    }
    if (!metric.YellowTargetSymbol || metric.YellowTargetSymbol == "null") {
      metric.YellowTargetSymbol = null;
    } else {
      metric.YellowMaximum = null;
      if (metric.YellowTargetSymbol === "Yes") metric.YellowMinimum = 2;
      else if (metric.YellowTargetSymbol === "No") metric.YellowMinimum = 1;
    }
    if (!metric.RedTargetSymbol || metric.RedTargetSymbol == "null") {
      metric.RedTargetSymbol = null;
    } else {
      metric.RedMaximum = null;
      if (metric.RedTargetSymbol === "Yes") metric.RedMinimum = 2;
      else if (metric.RedTargetSymbol === "No") metric.RedMinimum = 1;
    }
  }

  getMetrics(): void {
    this.errorMessages = [];
    if (!this.selectedQuarterId) {
      this.errorMessages.push("Please select Quarter");
    }
    if (!this.selectedYear) {
      this.errorMessages.push("Please select Year");
    }

    if (
      this.scoreCardMasterId === 0 &&
      this.selectedYear &&
      this.selectedQuarterId
    ) {
      if (
        this.scoreCardMasterList.findIndex(
          (ent) =>
            ent.Year === this.selectedYear.getFullYear() &&
            ent.QuarterId === this.selectedQuarterId
        ) > -1
      ) {
        this.errorMessages.push(
          "Score card already exist for selected quarter and year"
        );
      }
    }

    if (this.errorMessages.length != 0) {
      this.dialog.open(ValidationDialogComponent, {
        data: {
          errorMessages: this.errorMessages,
        },
      });
      return;
    }

    if (this.scoreCardMasterId == 0) {
      this.quarterName = this.quarterList.find(
        (ent) => ent.QuarterId == this.selectedQuarterId
      ).QuarterName;
      this.selectedYearName = this.selectedYear.getFullYear();
      var months = this.quarters.find(
        (ent) => ent.QuarterId === this.selectedQuarterId
      ).QuarterMonths;
      this.WeekDateList = this.quarterService.getWeekMonths(
        months,
        Number(this.selectedYearName),
        this.quarters[0].QuarterWeekDay,
        this.quarters[0].QuarterWeekDate
      );
    }
    //this.step++;
    this.safeStepChange(this.step + 1);
  }

  //step 2
  getSelectedMetrics(): void {
    this.errorMessages = [];
    if (this.selectedMetrics.length === 0) {
      this.errorMessages.push("Please select atleast one Metric");
    }

    if (this.errorMessages.length != 0) {
      this.dialog.open(ValidationDialogComponent, {
        data: {
          errorMessages: this.errorMessages,
        },
      });
      return;
    }
    this.processData();
    //this.step++;
    this.safeStepChange(this.step + 1);
  }

  //step 3
  generateWeeks(): void {
    this.errorMessages = [];

    var selectedFrequency = this.selectedMetrics.filter(
      (ent) => !ent.Frequency || ent.Frequency == "null"
    );
    if (selectedFrequency.length > 0) {
      this.errorMessages.push("Please select Frequency");
    }

    var selectedUOM = this.selectedMetrics.filter(
      (ent) => !ent.UOM || !ent.UOM.trim()
    );
    if (selectedUOM.length > 0) {
      this.errorMessages.push("Please enter UOM");
    }

    if (this.errorMessages.length != 0) {
      this.dialog.open(ValidationDialogComponent, {
        data: {
          errorMessages: this.errorMessages,
        },
      });
      return;
    }
    //this.step++;
    this.safeStepChange(this.step + 1);
  }

  //step 4
  generateScoreCard(): void {
    this.scoreCardPreview = true;
    this.saveScoreCardDetails(false);
    //this.step++;
    this.safeStepChange(this.step + 1);
  }

  saveScoreCardDetails(showDialog = true): void {
    if (this.scoreCardMasterId == 0) {
      this.scoreCardMaster = {
        Id: 0,
        CompanyID: this.companyId,
        ScoreCardType: this.scoreCard.ScoreCardType,
        DepartmentID: this.scoreCard.DepartmentId,
        TeamID: this.scoreCard.TeamId,
        QuarterId: this.selectedQuarterId,
        Year: Number(this.selectedYear.getFullYear()),
        ScoreCardName: this.getScoreCardName(),
        CreatedBy: this.currentUser,
        UpdatedBy: this.currentUser,
        QuarterName: "",
        CompanyName: "",
        DepartmentName: "",
        TeamName: "",
      };
    }
    this.performanceScoreCard = {
      scoreCardMaster: this.scoreCardMaster,
      pscMetricDetails: this.selectedMetrics,
      metricIds: this.toBeDeletedMetrics,
    };
    this.scoreCardService
      .SavePerformanceScoreCardDetails(this.performanceScoreCard)
      .subscribe((resp) => {
        if (resp.Data) {
          this.scoreCardMaster.Id = resp.Data.ScoreCardMaster.Id;
          this.scoreCardMasterId = resp.Data.ScoreCardMaster.Id;

          // Copy back saved metrics safely
          this.selectedMetrics = [...resp.Data.pscMetricDetails];
          this.selectedMetrics.forEach((ele) => {
            const found = this.pscMetricDetails.find(
              (p) => p.PointerID === ele.PointerID
            );
            if (found) {
              found.Id = ele.Id;
            }
          });

          if (showDialog) {
            this.dialog.open(ResponseDialogComponent, {
              data: {
                message: "Save successful",
              },
            });
          }
        }
      });
  }

  metricChange(metric): void {
    if (metric.IsSelected) {
      this.selectedMetrics.push(metric);
    } else {
      this.selectedMetrics = this.selectedMetrics.filter(
        (ent) => ent.PointerID != metric.PointerID
      );
      if (metric.Id != 0) {
        this.toBeDeletedMetrics.push(metric.Id);
      }
    }
  }

  //validations
  setTargets(metric): void {
    // kept intentionally empty (original had validations commented)
  }

  setStep(index: number): void {
    this.safeStepChange(index);
  }

  nextStep(): void {
    this.safeStepChange(this.step + 1);
  }

  prevStep(): void {
    this.safeStepChange(this.step - 1);
  }

  //step 0
  goToQuarterSelection(): void {
    this.selectedYearName = this.quarterName = undefined;
    this.safeStepChange(this.step - 1);
  }

  //step 1
  goToMetricList() {
    this.selectedMetrics = [...this.selectedMetrics];
    this.safeStepChange(this.step - 1);
  }

  goToGeneratedWeeks() {
    this.scoreCardPreview = false;
    this.safeStepChange(this.step - 1);
  }

  //private methods
  private getScoreCardName(): string {
    if (this.scoreCard.ScoreCardType === ScoreCardTypeEnum.Department) {
      return `${this.scoreCard.DepartmentName}_${
        this.quarterList.find((ent) => ent.QuarterId === this.selectedQuarterId)
          .QuarterName
      }_${this.selectedYear.getFullYear()}`;
    } else {
      return `${this.scoreCard.DepartmentName}_${this.scoreCard.TeamName}_${
        this.quarterList.find((ent) => ent.QuarterId === this.selectedQuarterId)
          .QuarterName
      }_${this.selectedYear.getFullYear()}`;
    }
  }

  private processData(): void {
    const goalSeen = {} as any;
    // Sort first
    this.selectedMetrics.sort((a, b) => a.GoalName.localeCompare(b.GoalName));
    // Then add goalSpan property directly (don't create new objects)
    this.selectedMetrics.forEach((x) => {
      x.goalSpan = goalSeen[x.GoalName]
        ? 0
        : this.selectedMetrics.filter((y) => y.GoalName === x.GoalName).length;
      goalSeen[x.GoalName] = true;
    });
  }

  // --- helper to prevent ExpressionChangedAfterItHasBeenCheckedError ---
  private safeStepChange(nextStep: number): void {
    // Run in next change detection cycle
    setTimeout(() => {
      this.step = nextStep;
    });
  }

  // sanitizeMetric now is pure and returns cleaned value (does NOT directly mutate the model)
  sanitizeMetricValue(value: any): any {
    // If value is undefined or null â†’ return null
    if (value === undefined || value === null) {
      return null;
    }

    // If it's a string â†’ clean it
    if (typeof value === "string") {
      let v = value.trim();

      // Remove surrounding quotes if present
      if (
        (v.startsWith("'") && v.endsWith("'")) ||
        (v.startsWith('"') && v.endsWith('"'))
      ) {
        v = v.slice(1, -1).trim();
      }

      // Treat empty, single-quote, or "null" (case-insensitive) as null
      if (v === "" || v === "'" || v === '"' || v.toLowerCase() === "null") {
        return null;
      }

      // Convert only if it's a valid numeric string
      if (!isNaN(parseInt(v)) && v.trim() !== "") {
        return parseFloat(v);
      }

      // Otherwise, keep cleaned string
      return v;
    }

    // If it's a number but invalid (NaN, Infinity), return null
    if (typeof value === "number" && !Number.isFinite(value)) {
      return null;
    }

    // otherwise return as-is
    return value;
  }
  // Use this on blur to safely update the model in the next tick to avoid CD errors
  onWeekBlur(rawValue: any, metric: any, i: number): void {
    setTimeout(() => {
      const key = "Week" + i;
      metric[key] = this.sanitizeMetricValue(rawValue);
      // ensure change detection after update
      try {
        this.cdr.detectChanges();
      } catch (e) {
        /* ignore */
      }
    });
  }
}
